import { LoaderActions } from '@store/loaders'
import { AuthActions } from '@store/reducers/auth'
import { InternalDashboardActions } from '@store/reducers/dashboard/actions'
import { selectDashboard } from '@store/reducers/dashboard/selectors'
import type { Workspace } from '@store/reducers/dashboard/types'
import { isAuthError } from '@store/reducers/dashboard/utils'
import { call, put, select } from 'redux-saga/effects'

import { NestClient } from '@/nest'

export function* dashboardInit() {
  const currentSpaces: Workspace[] = yield select(selectDashboard)
  // Always refetch: the list may be stale after SPA navigation (e.g. a project
  // created from the dashboard). The loader is only for the first load — while
  // data is present we keep showing it and silently swap in the fresh list.
  const initial = currentSpaces.length === 0

  if (initial) {
    yield put(LoaderActions.set('workspaces'))
  }

  try {
    const workspaces: Workspace[] = yield call(NestClient.workspaces.my)

    yield put(InternalDashboardActions.setWorkspaces(workspaces))
  } catch (error) {
    console.error('Failed to initialize dashboard workspaces:', error)

    // Nest reads the same token the PHP API does, so a 401 means the token
    // itself is dead. Anything else keeps whatever is on screen.
    if (isAuthError(error)) {
      yield put(AuthActions.logout())
    }
  } finally {
    if (initial) {
      yield put(LoaderActions.unset('workspaces'))
    }
  }
}
